












































import { Component } from 'vue-mixin-decorator';

import BaseView from '@/views/BaseView.vue';
import ExamHeader from '@/components/ExamHeader.vue';
import ExamFooter from '@/components/ExamFooter.vue';
import ExamGuide from '@/components/ExamGuide.vue';
import ExamNav from '@/components/ExamNav.vue';
import IndicatorModal from '@/components/IndicatorModal.vue';

import RepositoryFactory from '@/repository/RepositoryFactory';

import * as StringUtil from '@/common/StringUtil';

import * as DesignCode from '@/classification/DesignCode';

import DesignResource from '@/models/exam/DesignResource';
import Goods from '@/models/goods/Goods';

@Component(
  {
    components: {
      'e-header': ExamHeader,
      'e-footer': ExamFooter,
      'e-guide': ExamGuide,
      'e-nav': ExamNav,
      'e-indicator': IndicatorModal,
    },
  },
)
export default class GoodsList extends BaseView {
  private isIndicatorDisplay = false;

  private examTitle = '';

  private goodsList: Goods[] = [];

  private resources = {
    EXAM_RANK_ICON: new DesignResource(),
  };

  private async mounted() {
    this.isIndicatorDisplay = true;

    const CommonCss = document.createElement('link');
    CommonCss.rel = 'stylesheet';
    CommonCss.href = '/css/common.css';
    this.$el.appendChild(CommonCss);

    this.getExamConfigCss().then((cssElement: HTMLLinkElement) => {
      this.$el.appendChild(cssElement);
    });

    try {
      this.isIndicatorDisplay = true;
      await this.getExamInfo();
      await this.getGoodsList();
      this.isIndicatorDisplay = false;
    } catch (e) {
      this.$router.replace(this.paths.TOP);
    } finally {
      this.isIndicatorDisplay = false;
    }

    const CommonJs = document.createElement('script');
    CommonJs.src = '/js/common.js';
    this.$el.appendChild(CommonJs);
  }

  /**
   * 検定情報取得
   */
  private async getExamInfo() {
    // 検定情報APIを呼び出し、お知らせを生成
    const ExamRepository = RepositoryFactory.get().exam;
    await ExamRepository.getExam().then((response) => {
      if (response.status === 200) {
        this.examTitle = response.data.exam_title;

        // デザインリソース
        if (response.data.resources !== undefined) {
          response.data.resources.forEach((resource: any) => {
            const key = resource.display_place_key;
            if (key in this.resources) {
              const tmp = new DesignResource();
              tmp.displayPlaceKey = resource.display_place_key;
              tmp.displayText = StringUtil.isEmpty(resource.display_text) ? '' : resource.display_text;
              tmp.cssClassName = StringUtil.isEmpty(resource.css_class_name) ? '' : resource.css_class_name;
              tmp.resourceUri = StringUtil.isEmpty(resource.resource_uri) ? '' : resource.resource_uri;
              tmp.resourceFileName = StringUtil.isEmpty(resource.resource_file_name) ? '' : resource.resource_file_name;
              tmp.alternativeText = StringUtil.isEmpty(resource.alternative_text) ? '' : resource.alternative_text;
              // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
              // @ts-ignore
              this.resources[key] = tmp;
            }
          });
        }
      }
    });
  }

  /**
   * グッズ一覧取得
   */
  private async getGoodsList() {
    const GoodsRepository = RepositoryFactory.get().goods;
    await GoodsRepository.getGoodsList().then((response: any) => {
      if (response.status === 200) {
        response.data.goods_list.forEach((goods: any) => {
          const goodsObj = new Goods();
          goodsObj.goodsCode = StringUtil.encodeToBase64Url(goods.goods_code);
          goodsObj.goodsTitle = goods.goods_title;
          if (goods.fees.length > 0) {
            goodsObj.fee = StringUtil.separateNumber(goods.fees[0].fee);
          } else {
            goodsObj.fee = '0';
          }

          // eslint-disable-next-line prefer-destructuring
          const resources = goods.resources;
          if (resources !== undefined && resources.length > 0) {
            resources.forEach((resource: any) => {
              if (resource.display_place_key === DesignCode.EXAM_RANK_ICON) {
                goodsObj.thumbnail = resource.resource_uri;
                goodsObj.alternativeText = resource.alternative_text;
              }
            });
          }
          this.goodsList.push(goodsObj);
        });
      }
    });
  }
}
